export default __webpack_public_path__ + "static/media/9.d12ae523.jpg";